export const APP_CONFIG = {
    production: false,
    apiUrl: 'https://dev-qc-api.onteammateai.com/api/v1',
    appUrl: 'https://dev-qc-frontend.onteammateai.com',
    debug: true,
};
